import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "115%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const staggerContainer = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12 } },
};

export const staggerItem = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: EASE } },
};

export const Kicker = ({ children, light = false, className = "" }) => (
  <p
    className={`font-display text-xs font-semibold uppercase tracking-[0.16em] ${
      light ? "text-mintlight" : "text-goldtext"
    } ${className}`}
  >
    {children}
  </p>
);

/** Section heading with a line-by-line mask reveal when scrolled into view. */
export const SectionTitle = ({ children, light = false, className = "", as: Tag = "h2" }) => (
  <Tag
    className={`mt-4 font-display text-3xl font-semibold leading-[1.15] md:text-[2.4rem] ${
      light ? "!text-white" : "text-ink"
    } ${className}`}
  >
    <span className="block overflow-hidden">
      <motion.span
        className="block"
        initial={{ y: "105%" }}
        whileInView={{ y: "0%" }}
        viewport={{ once: true, margin: "-10% 0px" }}
        transition={{ duration: 1, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  </Tag>
);
